/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Badge, CircularProgress, ClickAwayListener, DialogActions, DialogContent, DialogTitle, MenuItem, MenuList, Paper, Popper, TextField, Theme } from '@mui/material';
import classNames from 'classnames';
import { Switch, FormControlLabel, Typography, Box, styled, createTheme, ThemeProvider } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Dialog from '@mui/material/Dialog';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import { withStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import AccountCircle from '@mui/icons-material/AccountCircle';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InfoIcon from '@mui/icons-material/Info';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import * as React from 'react';
import { connect } from 'react-redux';
import { NavLink, Routes, Route } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { categories, CategoryType } from '../common/Categories';
import { clearvaluesonlogout, isAdministrator, resetHubConnection, sendRequestAndReceiveResponse } from '../common/common';
import {
    allproductRoute, alltrainingRoute, authorizationRoute, bulletinRoute, dashboardRoute, downloadsRoute, editUserRoleRoute,
    editUserRoute, getfatlasdownloaddataEndpoint, getSubscriptionEndpoint, GSInfoRoute, instrumentConstantsRoute, laborTimeGuideRoute, licenseRoute, manageEmailSubscriptionsEndpoint, manualRoute,
    notificationRoute, signincallbackRoute, teamproductRoute, teamTrainingRoute, useradminRoute, userRoleRoute, BASE_URL
} from '../common/constants';
import { loadFromLocalStorage } from '../common/localStorage';
import { routes } from '../common/routes';
import downloadatlas from '../images/Atlas_IconNew.png';
import DownloadIcon from '../images/downloadatlas.svg';
import tisLinkIcon from '../images/tis-link-custom.svg';
import logo from '../images/Trimble_NewLogo.png';
import { AuthService } from '../services/AuthServices';
import { history } from '../store/history';
import { withNavigation } from '../common/withNavigation';
import { actionCreators as navMenuActionCreators } from '../store/NavMenu';
import { actionCreators as notificationActionCreator } from '../store/Notification';
import { actionCreators as viewManualActionCreators } from '../store/ViewManual';
import { actionCreators as dashboardActionCreators } from '../store/Dashboard';
import AllProductAuthorizations from './AllProductAuthorizations';
import AllTrainingAuthorizations from './AllTrainingAuthorizations';
import Authorization from './Authorization';
import Dashboard from './Dashboard';
import Downloads from './Downloads';
import GeneralServiceInformation from './GeneralServiceInformation';
import InstrumentConstants from './InstrumentConstants';
import LaborTimeGuide from './LaborTimeGuide';
import License from './License';
import MyTrainingAuthorizations from './MyTrainingAuthorizations';
import './NavMenu.css';
import Notification from './Notification';
import Role from './Role';
import RoleEdit from './RoleEdit';
import ServiceBulletin from './ServiceBulletin';
import ServiceManual from './ServiceManual';
import SigninCallBack from './Signin-CallBack';
import './styles.css';
import TeamProductAuthorizations from './TeamProductAuthorizations';
import TeamTrainingAuthorizations from './TeamTrainingAuthorizations';
import UserAdmin from './UserAdmin';
import UserEdit from './UserEdit';
import UserTable from './UserTable';
import { BorderAllRounded } from '@mui/icons-material';
import { withRouterCompat, RouteComponentPropsCompat } from '../common/withRouter';
const drawerWidth = 250;

// Styled Toggle Switch
const CustomSwitch = styled(Switch)(({ theme }) => ({
    width: 70,
    height: 30,
    padding: 0,
    display: "flex",
    "& .MuiSwitch-switchBase": {
        padding: 2,
        "&.Mui-checked": {
            transform: "translateX(40px)",
            "& + .MuiSwitch-track": {
                backgroundColor: "#007500", // Stronger green when ON
                //opacity: 0.5, // Ensures it looks vibrant
            },
        },
        "&:hover": {
            backgroundColor: "transparent",
        },
        "&:focus": {
            outline: "none",
        },
    },
    "& .MuiSwitch-thumb": {
        width: 26,
        height: 26,
        backgroundColor: "#fff", // Thumb remains white
        boxShadow: "none",
    },
    "& .Mui-checked .MuiSwitch-thumb": {
        backgroundColor: "#fff",
    },
    "& .MuiSwitch-track": {
        borderRadius: 15,
        backgroundColor: "#d32f2f", // Red when OFF
        //opacity: 1, // Ensures full color visibility
        transition: "background-color 0.3s",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 8px",
        fontSize: "12px",
        fontWeight: "bold",
        color: "#fff",
    },
    "& .MuiSwitch-track::before": {
        content: '"On"',
        position: "absolute",
        left: "10px",
        fontSize: "12px",
        fontWeight: "bold",
        color: "#fff",
    },
    "& .MuiSwitch-track::after": {
        content: '"Off"',
        position: "absolute",
        right: "10px",
        fontSize: "12px",
        fontWeight: "bold",
        color: "#fff",
    },
    "& .Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#007500",
        opacity: 1,// Bright & strong green
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
        backgroundColor: "#fff !important",
    },
 
}));


const styles = (theme: Theme) => ({
    root: {
        display: 'flex'
    },
    active: {
        backgroundColor: (theme && (theme as any).palette && (theme as any).palette.secondary && (theme as any).palette.secondary.main)
            || '#1976d2'
    },
    appBar: {
        zIndex: ((theme && (theme as any).zIndex && (theme as any).zIndex.drawer) || 1200) + 1,
        transition: (theme && (theme as any).transitions && (theme as any).transitions.create)
            ? (theme as any).transitions.create(['width', 'margin'], {
                easing: (theme as any).transitions.easing.sharp,
                duration: (theme as any).transitions.duration.leavingScreen
            })
            : 'none',
        backgroundColor: (theme && (theme as any).palette && (theme as any).palette.common && (theme as any).palette.common.white)
            || '#ffffff',
        boxShadow: 'none',
        borderColor: (theme && (theme as any).palette && (theme as any).palette.primary && (theme as any).palette.primary.main)
            || '#1976d2'
    },
    appBarShift: {
        marginLeft: drawerWidth,
        transition: (theme && (theme as any).transitions && (theme as any).transitions.create)
            ? (theme as any).transitions.create(['width', 'margin'], {
                easing: (theme as any).transitions.easing.sharp,
                duration: (theme as any).transitions.duration.enteringScreen
            })
            : 'none'
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36
    },
    hide: {
        display: 'none'
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        backgroundColor: '#292836',
        overflowY: 'auto'
    },
    drawerOpen: {
        width: drawerWidth,
        transition: (theme && (theme as any).transitions && (theme as any).transitions.create)
            ? (theme as any).transitions.create('width', {
                easing: (theme as any).transitions.easing.sharp,
                duration: (theme as any).transitions.duration.enteringScreen
            })
            : 'none',
        backgroundColor: '#292836',
        overflowY: 'auto'
    },
    drawerClose: {
        transition: (theme && (theme as any).transitions && (theme as any).transitions.create)
            ? (theme as any).transitions.create('width', {
                easing: (theme as any).transitions.easing.sharp,
                duration: (theme as any).transitions.duration.leavingScreen
            })
            : 'none',
        overflowX: 'hidden',
        width: `calc(${(theme && (theme as any).spacing) ? (theme as any).spacing(5) : 40}px + 1px)`,
        [((theme && (theme as any).breakpoints) ? (theme as any).breakpoints.up('sm') : '@media (min-width:600px)')]: {
            width: `calc(${(theme && (theme as any).spacing) ? (theme as any).spacing(7) : 56}px + 1px)`
        },
        backgroundColor: '#292836',
        borderRight: '3px solid #045891',
        overflowY: 'auto'
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...(theme && (theme as any).mixins && (theme as any).mixins.toolbar ? (theme as any).mixins.toolbar : {})
    },
    content: {
        flexGrow: 1,
        marginLeft: '70px',
        padding: '0 24px 16px 24px',
        transition: (theme && (theme as any).transitions && (theme as any).transitions.create)
            ? (theme as any).transitions.create(['margin', 'padding'], {
                easing: (theme as any).transitions.easing.sharp,
                duration: (theme as any).transitions.duration.leavingScreen
            })
            : 'none'
    },
    contentShift: {
        marginLeft: drawerWidth,
        transition: (theme && (theme as any).transitions && (theme as any).transitions.create)
            ? (theme as any).transitions.create(['margin', 'padding'], {
                easing: (theme as any).transitions.easing.sharp,
                duration: (theme as any).transitions.duration.enteringScreen
            })
            : 'none'
    },
    notificationContent: {
        flexGrow: 1,
        marginLeft: '70px',
        padding: '10px 24px 16px 24px',
        transition: (theme && (theme as any).transitions && (theme as any).transitions.create)
            ? (theme as any).transitions.create(['margin', 'padding'], {
                easing: (theme as any).transitions.easing.sharp,
                duration: (theme as any).transitions.duration.leavingScreen
            })
            : 'none'
    },
    notificationContentShift: {
        marginLeft: drawerWidth,
        transition: (theme && (theme as any).transitions && (theme as any).transitions.create)
            ? (theme as any).transitions.create(['margin', 'padding'], {
                easing: (theme as any).transitions.easing.sharp,
                duration: (theme as any).transitions.duration.enteringScreen
            })
            : 'none'
    },
    link: {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none'
        }
    },
    current: {
        color: '#ffbe00 !important'
    },
    listItem: {
        '&:hover': {
            backgroundColor: '#005f9e',
            color: (theme && (theme as any).palette && (theme as any).palette.primary && (theme as any).palette.primary.main)
                || '#1976d2'
        },
        marginTop: 2,
    },
    rightToolbar: {
        marginLeft: 'auto'
    },
    iconStyle: {
        fontSize: 36,
        marginLeft: '-4px',
        paddingRight: 2
    },
    bottom: {
        marginTop: 'auto'
    },
    backButton: {
        minWidth: '2px',
        marginTop: '7px',
    },
    backButtonIcon: {
        marginLeft: '50%'
    },
    notificationButton: {
        marginRight: '5px',
        height: '45px'
    },
    menuList: {
        backgroundColor: '#292836',
        padding: '0',
        width: drawerWidth,
    },
    menuItem: {
        color: '#fff',
        '&:hover': {
            backgroundColor: '#005f9e',
        },
        fontSize: '14px',
        lineHeight: '22px',
        paddingTop: 11,
        paddingBottom: 11
    },
    defaultSelected: {
        backgroundColor: '#292836',
        '&:hover': {
            backgroundColor: '#005f9e'
        }
    },
    listItemIcon: {
        marginRight: 0,
        width: 24,
        height: 24,
        marginTop: -9,
        minWidth: 24
    },
    listItemText: {
        fontSize: '14px',
        paddingLeft: 16
    },
    menuItemHeader: {
        backgroundColor: '#005f9e !important',
        color: '#fff',
        borderBottom: '1px solid #005f9e',
        fontSize: '14px',
        lineHeight: '24px',
        fontWeight: 'bold',
        width: '100%',
        paddingTop: 11,
        paddingBottom: 11,
        '&:hover': {
            cursor: 'default'
        },
    },
    subMenuItem: {
        maxWidth: '100% !important',
        margin: '0 !important',
        padding: '9px 16px',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    selectedMenu: {
        backgroundColor: '#005f9e !important',
        '&.Mui-selected': {
            backgroundColor: '#005f9e !important'
        },
        '&.Mui-selected:hover': {
            backgroundColor: '#005f9e !important'
        }
    },
    avatorImage: {
        borderRadius: '50%',
        marginLeft: '-4px'
    },
    avatorStyleContainer: {
        display: 'inline-block',
        borderRadius: '100%', 
        border: 'black',
        borderWidth: 'thin',
        borderStyle: 'solid',
    },
    avatorStyle: {
        width: '150px',
        height: '150px',
        borderRadius: 'inherit'
    },
    textFieldContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '40px'
    },
    textField: {
        width: '45%',
    },
    toggleContainer: {
        marginTop: '30px'
    },
    profileItem: {
        marginBottom: 10
    },
    signOutItem: {
        marginTop: 10
    },
    tisLinkIcon: {
        width: 38,
        height: 38,
        display: 'block',
        marginTop: -2,
        marginLeft: -7,
    },
});

interface Props extends RouteComponentPropsCompat {
    dialogOpen: boolean;
    setDialogOpen: Function;
    theme: Theme;
    classes?: any;
    children?: any;
    notificationCount?: any;
    username?: string;
    userimage?: string;
    getNotificationCount: Function;
    resetNotificationCount: Function;
    UpdateMenuExpanded: Function;
    ClearViewManualData: Function;
    navigate?: (path: string) => void;
}
interface State {
    open: boolean;
    toggleChecked: boolean;
    isToggleDisabled: boolean;
    opendownloadatlas: boolean;
    loggedInUser: string,
    loggedInUserImage: string,
    selectedPage: Object,
    pages: Array<Object>,
    isRunningFromDesktop: boolean,
    menuOpen: any,
    pagename: string,
    faqlink: any,
    quickguidelink: any,
    atlasversion: any,
    releasedate: any,
    atlasdownloadlink: any,
    anchorEl: any,
    notificationPageVisible: boolean,
    prevPage: string,
    tisLinkUrl: any,
}

class NavMenu extends React.PureComponent<
    Props,
    State
> {
        private routeMap: Record<string, string> = {
            dashboard: dashboardRoute,
            license: licenseRoute,
            authorization: authorizationRoute,
            notification: notificationRoute,
            useradmin: useradminRoute,
            'useradmin/userrole': userRoleRoute,
            manual: manualRoute,
            bulletins: bulletinRoute,
            gsinfo: GSInfoRoute,
            labortimeguide: laborTimeGuideRoute,
            downloads: downloadsRoute,
            instrumentConstants: instrumentConstantsRoute,
            teamtraining: teamTrainingRoute,
            teamproduct: teamproductRoute,
            alltraining: alltrainingRoute,
            allproduct: allproductRoute
        };
    public state = {
        open: false,
        opendownloadatlas: false,
        toggleChecked: false,
        isToggleDisabled: true,
        faqlink: '',
        quickguidelink: '',
        atlasversion: '',
        releasedate: '',
        atlasdownloadlink: '',
        tisLinkUrl: '',
        loggedInUser: '',
        loggedInUserImage: '',
        pagename: '',
        selectedPage: 'Dashboard',
        pages: [
            {
                page: 'Dashboard', name: 'dashboard', icon: <DashboardIcon className={this.props.classes.iconStyle} />, isVisible: true,
                innerPages: [
                    { name: 'dashboard', page: 'Service Cases', category: [CategoryType.ServiceCase] },
                    { name: 'license', page: 'Licenses', category: [CategoryType.License] },
                    { name: 'authorization', page: 'Product Training', category: [CategoryType.TrainingAuthorization, CategoryType.ProductAuthorization] }
                ]
            },
            {
                page: 'Service Information', name: 'serviceInformation', icon: <InfoIcon className={this.props.classes.iconStyle} />, isVisible: true,
                innerPages: [
                    { name: 'manual', page: 'Service Manuals', category: [CategoryType.ServiceManual] },
                    { name: 'bulletins', page: 'Service Bulletins', category: [CategoryType.ServiceBulletin] },
                    { name: 'gsinfo', page: 'General Service Information', category: [CategoryType.GSInfo] },
                    { name: 'labortimeguide', page: 'Labor Time Guide', category: [CategoryType.LaborTimeGuide] },
                    { name: 'downloads', page: 'Downloads', category: [CategoryType.Downloads] },
                    { name: 'instrumentConstants', page: 'Instrument Constants', category: [CategoryType.InstrumentConstants] }
                ]
            },
            {
                page: 'User Admin', name: 'useradmin', icon: <SupervisorAccountIcon className={this.props.classes.iconStyle} />, isVisible: true, isAdmin: true,
                innerPages: [
                    { name: 'useradmin', page: 'Users', category: [CategoryType.User] },
                    { name: 'useradmin/userrole', page: 'User Roles', category: [CategoryType.UserRole] },
                ]
            }
        ],
        isRunningFromDesktop: false,
        menuOpen: [],
        anchorEl: [],
        notificationPageVisible: false,
        prevPage: ''
    };
    setCurrentPageHeader() {
        // Resolve current route from window location to avoid relying on children props
        const pathname = window.location && window.location.pathname ? window.location.pathname.toLowerCase() : '';
        const normalizedPath = BASE_URL && pathname.startsWith(BASE_URL.toLowerCase())
            ? pathname.substring(BASE_URL.length)
            : pathname;
        const currentroute: any = routes.find((x: any) =>
            normalizedPath.startsWith((x.route || '').toLowerCase())
        );
        if (currentroute) {
            let page: any = '', selectedPage: any = '';
            this.state.pages.forEach((x: any) => {
                if (x.innerPages !== undefined) {
                    const a = x.innerPages.find((y: any) => y.name === currentroute.routename);
                    if (a !== undefined) {
                        page = a.page;
                        selectedPage = x.page;
                    }
                }
                else if (x.name === currentroute.routename) {
                    page = x.page;
                    selectedPage = x.page;
                }
            });
            if (page !== undefined && selectedPage !== undefined && selectedPage !== '') {
                this.setState({ pagename: page, selectedPage, notificationPageVisible: true });
            } else if (!this.state.selectedPage) {
                // Fallback to Dashboard as default selection when route not resolved
                this.setState({ selectedPage: 'Dashboard', notificationPageVisible: true });
            } else {
                // Ensure the notification icon is visible even if page header couldn't be resolved
                this.setState({ notificationPageVisible: true });
            }
        } else {
            // No matching route found; still show notification icon
            this.setState({ notificationPageVisible: true });
        }
    }
    componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        const prevPath = prevProps.location?.pathname || '';
        const currentPath = this.props.location?.pathname || '';
        if (prevPath !== currentPath) {
            this.setCurrentPageHeader();
        }
    }
    getTimeDifference = (expirtDate: any) => {
        const currentDate: any = new Date();
        return (expirtDate - currentDate);
    };
    handledownload = () => {
        this.setState({ opendownloadatlas: !this.state.opendownloadatlas });
    };
    handleTisLinkRedirect = () => {
        const tisLinkUrl = this.state.tisLinkUrl;
        if (!tisLinkUrl || !tisLinkUrl.trim()) {
            return;
        }
        window.open(tisLinkUrl, '_blank', 'noopener,noreferrer');
    };
    handleListItemClick = () => {
        this.props.setDialogOpen(true);
    };

    handleCloseDialog = () => {
        this.props.setDialogOpen(false);
    };
    handleToggleChange = async (event: { target: { checked: any; }; }) => {
        const newChecked = event.target.checked;
        this.setState({ toggleChecked: newChecked, isToggleDisabled: true });

        try
        {
            const response = await sendRequestAndReceiveResponse(JSON.stringify({
                SubscriptionType: 'ServiceBulletinNotification',
                EnableEmailNotification: newChecked,
            }), manageEmailSubscriptionsEndpoint);
            console.log(response);
            if (response.message !== 'successfully subscribed') {
                throw new Error('Subscription update failed');
            }
        }
        catch (error)
        {
            console.error('Error updating subscription:', error);
            this.setState({ toggleChecked: !newChecked });
        }
        finally {
                this.setState({ isToggleDisabled: false });
        }
    };
    LoadAtlasData = async () => {
        const data = await sendRequestAndReceiveResponse(JSON.stringify('Atlas DownloadData'), getfatlasdownloaddataEndpoint);
        this.setState({ faqlink: data[0] });
        this.setState({ quickguidelink: data[1] });
        this.setState({ atlasversion: data[2] });
        this.setState({ releasedate: data[3] });
        this.setState({ atlasdownloadlink: data[4] });
        this.setState({ tisLinkUrl: data[5] });
    };
    refresh = () => {
        const refreshToken = loadFromLocalStorage('RefreshToken');
        if (refreshToken != null && refreshToken !== undefined) {
            new AuthService().RefreshToken(refreshToken);
            this.setState({ loggedInUserImage: loadFromLocalStorage('UserImage') });
        }
    };

    componentDidMount() {
        let expiryTimeMs: any = 2700000;
        const expiryTime = loadFromLocalStorage('ExpiryTime');
        

        if (expiryTime != null && expiryTime !== undefined) {
            expiryTimeMs = Math.floor(this.getTimeDifference(new Date(expiryTime)));
        }
        //refresh with respect to expirytime. This is to handle browser refresh
        let interval = setInterval(() => {
            this.refresh();
            //Clears interval so that we can again set it for 45 mins
            clearInterval(interval);
            //Refresh after 45 mins
            interval = setInterval(() => {
                this.refresh();
            }, 2700000);
        }, expiryTimeMs);

        this.LoadAtlasData();
        this.setCurrentPageHeader();
        this.setState({ loggedInUser: loadFromLocalStorage('UserName') });
        this.setState({ loggedInUserImage: loadFromLocalStorage('UserImage') });
        if (isAdministrator()) {
            this.setState(
                (prevState: State, props: Props) => {
                    const pages: any = Object.assign([], prevState.pages);
                    const userAdminPageIndex = pages.findIndex((x: any) => {
                        return x.name === 'useradmin';
                    });
                    pages[userAdminPageIndex].isVisible = true;
                    return {
                        pages
                    };
                });
        }
        else {
            this.setState(
                (prevState: State, props: Props) => {
                    const pages: any = Object.assign([], prevState.pages);
                    const userAdminPageIndex = pages.findIndex((x: any) => {
                        return x.name === 'useradmin';
                    });
                    pages[userAdminPageIndex].isVisible = false;
                    return {
                        pages
                    };
                });
        }
        const clientMode: any = loadFromLocalStorage('Client Mode');
        if (clientMode != null && clientMode !== undefined && clientMode === 'Desktop') {
            this.setState({ isRunningFromDesktop: true });
        }
        if (this.props.notificationCount === undefined) {
            this.props.getNotificationCount();
        }
        this.fetchEmailSubscriptionStatus();
    }

    fetchEmailSubscriptionStatus = async () => {
        try {
            const waitForAuthToken = async (interval = 200, maxRetries = 50) => {
                let retries = 0;
                while (retries < maxRetries) {
                    const token = loadFromLocalStorage('AuthToken');
                    if (token && token.trim() !== '') {
                        return token;
                    }
                    await new Promise(resolve => setTimeout(resolve, interval));
                    retries++;
                }
                throw new Error('AuthToken not found in localStorage after waiting.');
            };
            await waitForAuthToken();
            const response = await sendRequestAndReceiveResponse(null, getSubscriptionEndpoint, 'GET');
            const subscription = response.subscriptions.find((sub: { subscriptionType: any; }) => sub.subscriptionType === 'ServiceBulletinNotification');
            if (subscription) {
                this.setState({ toggleChecked: subscription.isSubscribed });
            }
        } catch (error) {
            console.error('Error fetching EmailSubscriptionStatus: ', error);
        }
        finally {
            this.setState({ isToggleDisabled: false });
        }
    };

    handleDrawerOpen = () => {
        this.setState({ open: !this.state.open }, () => {
            this.props.UpdateMenuExpanded(this.state.open);
        });
    };

    handleDrawerClose = () => {
        this.setState({ open: false });
    };

    handleDownloadatlasClose = () => {
        this.setState({ opendownloadatlas: false });
    };
    handleMenu = (event: any) => {
        this.setState({ anchorEl: { [event.target.id]: event.currentTarget } });
    };
    handleDownloadLink = (presignedUrl: any, fileName: string) => {
        const xhr = new XMLHttpRequest;
        xhr.responseType = 'blob';

        xhr.onload = function () {
            const recoveredBlob = xhr.response;
            const url = URL.createObjectURL(recoveredBlob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        };
        xhr.open('GET', presignedUrl);
        xhr.send();
    };

    handleClose = () => {
        this.setState({ anchorEl: [] });
        this.props.resetNotificationCount();
        resetHubConnection();
    };

    handleMenuClose = (event: any) => {
        const x: any = Object.values(this.state.anchorEl);
        if (x !== undefined && x.length && x[0].contains(event.target)) {
            return;
        }
        this.setState({ menuOpen: { [event.currentTarget.id]: false } });
    };
    handleLogout = () => {
        clearvaluesonlogout();
        this.props.ClearViewManualData();
        this.handleClose();
        new AuthService().SignOut();
    };
    handlePageClick = (page: any) => {
        this.setState({ selectedPage: page.page });

    };
    showMenu = (event: any) => {
        if (!this.state.open) {
            this.setState({
                anchorEl: { [event.currentTarget.id]: event.currentTarget }
                , menuOpen: { [event.currentTarget.id]: true }
            });
        }
    };


    handleMenuClick = (suggestion: any, pageheader: any, page: any) => (event: any) => {
        this.setState({
            menuOpen: { [event.currentTarget.id]: false }
            , pagename: pageheader, selectedPage: page.page
        });
        const route = this.routeMap[suggestion] || `/${suggestion}`;
        // Navigate using path relative to basename for React Router
        if (this.props.navigate) {
            this.props.navigate(route);
        } else {
            // For legacy history, use full path with BASE_URL
            history.push(`${BASE_URL}${route}`);
        }
    };
    goToPrevPage = () => {
        const target = this.state.prevPage || '/dashboard';
        if (this.props.navigate) {
            this.props.navigate(target);
        }
    };
    setPrevPage = () => {
        this.setState({ prevPage: window.location.pathname.replace(BASE_URL, '') });
    };
    render() {
        const { classes, theme, username } = this.props;
        const { loggedInUser, loggedInUserImage, isRunningFromDesktop, opendownloadatlas } = this.state;
        const nameToSplit = (username !== undefined && username !== '') ? username : loggedInUser;
        const [firstName, lastName] = nameToSplit ? nameToSplit.split(' ') : ['', ''];
        const hasAvatarImage = this.props.userimage !== '' || (loggedInUserImage !== '' && loggedInUserImage !== undefined);
        const enabledModules: Array<any> = loadFromLocalStorage('Enabled Modules');
        let enabledCategories: any = [];
        if (enabledModules !== undefined) {
            enabledCategories = categories.filter(x => enabledModules.find(y => y.modulename === x.moduleName) !== undefined);
        }
        return (
            <div className={classes.root}>
                <CssBaseline />
                <AppBar
                    position="fixed"
                    className={classNames(classes.appBar, {
                        [classes.appBarShift]: this.state.open
                    })}
                >
                    <Toolbar disableGutters={true} style={{ borderBottom: '3px solid #045891' }}>
                        {!isRunningFromDesktop &&
                            <div>
                                <IconButton
                                    aria-label="Open drawer"
                                    onClick={this.handleDrawerOpen}
                                >
                                    <MenuIcon />
                                </IconButton>
                            </div>
                        }
                        {!isRunningFromDesktop && <img src={logo} width="143px" height="33px" />}
                        {window.location.pathname.includes(notificationRoute) && <Button onClick={this.goToPrevPage} className={classes.backButton}>
                            <ArrowBackIosIcon className={classes.backButtonIcon} /></Button>}
                        <span className="dashboard"> &nbsp; {window.location.pathname.includes(notificationRoute) ? 'Notification' : this.state.pagename}</span>
                        {!isRunningFromDesktop && !opendownloadatlas &&
                            <Tooltip title="Download Atlas Desktop">
                                <Button id="downloadatlas-button" onClick={() => { this.handledownload(); }}>
                                    <img src={DownloadIcon}
                                        className="downloadicon" />
                                </Button>
                            </Tooltip>}
                        <Dialog open={this.state.opendownloadatlas} onClose={this.handleClose} aria-labelledby="simple-dialog-title" scroll="paper" PaperProps={{
                            style: {
                                minHeight: '30%',
                                maxHeight: '130%',
                            }
                        }}>
                            <div style={{ height: 400 }}>
                                <div> <img src={downloadatlas} className="AtlasInstallImage" /> </div>
                                <div style={{ marginLeft: 30, marginRight: 30 }}>
                                    Atlas desktop installation requires an active Atlas license.
                                </div>
                                <div style={{ marginLeft: 30, marginTop: 5, color: 'grey' }}>
                                    Release Date <span style={{ marginLeft: 10 }}>:</span> <span style={{ fontWeight: 'bold', fontSize: 14, marginLeft: 10 }}>
                                        {this.state.releasedate}</span>
                                </div>
                                <div style={{ marginLeft: 30, color: 'grey' }}>
                                    Version <span style={{ marginLeft: 48 }}>:</span><span style={{ fontWeight: 'bold', fontSize: 14, marginLeft: 14 }}>
                                        {this.state.atlasversion}</span>
                                </div>
                                <div onClick={() => this.handleDownloadLink(this.state.faqlink, 'Atlas_FAQ.pdf')}
                                    style={{ cursor: 'pointer', color: 'blue', marginLeft: 30, marginTop: 10 }}>
                                    Atlas FAQ
                                </div>
                                <div onClick={() => this.handleDownloadLink(this.state.quickguidelink, 'QuickStartGuide.pdf')}
                                    style={{ cursor: 'pointer', color: 'blue', marginLeft: 30, marginTop: 10 }}>

                                    Quick Start Guide
                                </div>

                                <div className={classes.buttons}>
                                    <Button className="button"
                                        onClick={() =>
                                            this.handleDownloadatlasClose()
                                        }
                                        variant="outlined"
                                        style={
                                            {
                                                backgroundColor: 'white',
                                                justifyContent: 'center',
                                                marginLeft: 40,
                                                marginBottom: 0,
                                                marginTop: 15,
                                                color: 'Black',
                                                borderRadius: 4
                                            } as React.CSSProperties}>Cancel</Button>
                                    <a href={this.state.atlasdownloadlink} download="AtlasSetup.exe">
                                        <Button className="button" variant="outlined" style={
                                            {
                                                backgroundColor: '#0063a3',
                                                justifyContent: 'center',
                                                marginLeft: 205,
                                                marginBottom: 0,
                                                marginTop: 15,
                                                color: 'White',
                                                borderRadius: 4
                                            } as React.CSSProperties}>Download</Button>
                                    </a>
                                </div>
                            </div>
                        </Dialog>
                        {this.state.notificationPageVisible &&
                            <NavLink to={notificationRoute}>
                                <Button onClick={() => {
                                    this.setPrevPage();
                                    this.setState({ selectedPage: '', pagename: '' });
                                }} className={classes.notificationButton}>
                                    <Badge badgeContent={this.props.notificationCount !== undefined ? this.props.notificationCount : 0} color={'primary'}>
                                        <NotificationsNoneIcon className="notification" />
                                    </Badge>
                                </Button>
                            </NavLink>
                        }
                    </Toolbar>
                </AppBar>
                {!isRunningFromDesktop && <Drawer
                    variant="permanent"
                    className={classNames(classes.drawer, {
                        [classes.drawerOpen]: this.state.open,
                        [classes.drawerClose]: !this.state.open
                    })}
                    classes={{
                        paper: classNames({
                            [classes.drawerOpen]: this.state.open,
                            [classes.drawerClose]: !this.state.open
                        })
                    }}
                    open={this.state.open}
                >
                    {/*<div className={classes.toolbar}>
            <IconButton onClick={this.handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </div>
                <Divider />*/}
                    <div style={{ marginTop: 65 }} />
                    <List>
                        {this.state.pages.map((page: any) => (
                            (
                                page.isVisible &&
                                page.innerPages !== undefined && page.innerPages.length &&
                                (
                                    (page.isAdmin ? true : (page.innerPages.find((xy: any) =>
                                    (xy.category !== undefined ?
                                        (enabledCategories.find((a: any) => xy.category.find((ab: any) => ab === a.type) !== undefined) !== undefined) : true)
                                    ) !== undefined)) &&
                                    <div key={page.page}><ListItemButton
                                        style={{ paddingRight: 16 }}
                                        selected={this.state.selectedPage === page.page}
                                        className={classNames(
                                            (!this.state.open && this.state.selectedPage === page.page)? classes.selectedMenu : classes.defaultSelected,
                                            classes.listItem,
                                            classes.listItemText
                                        )} key={page.page} id={page.page}
                                        onClick={() => this.handlePageClick(page)}
                                        onMouseOver={this.showMenu} onMouseLeave={this.handleMenuClose}>
                                        <Popper key={page.page} open={this.state.menuOpen[page.page] && !this.state.open}
                                            id={page.page} anchorEl={this.state.anchorEl[page.page]}
                                            placement={'right-start'}
                                            modifiers={[{ name: 'offset', options: { offset: [0, -3] } }]}>
                                            <Paper>
                                                <ClickAwayListener onClickAway={this.handleMenuClose}>
                                                    <MenuList key={page.page} className={classes.menuList}>
                                                        <MenuItem className={classes.menuItemHeader}>{page.page}</MenuItem>
                                                        {page.innerPages.map((xy: any) => {
                                                            return (
                                                                (page.isAdmin ? true : (xy.category !== undefined ?
                                                                    enabledCategories.find((a: any) => xy.category.find((ab: any) => ab === a.type) !== undefined) !== undefined : true)) &&
                                                                <MenuItem className={classes.menuItem} key={xy.page} value={xy.page}
                                                                    onClick={this.handleMenuClick(xy.name, xy.page, page)}>{xy.page}</MenuItem>);
                                                        })
                                                        }
                                                    </MenuList>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Popper>
                                        <ListItemIcon className={classes.listItemIcon}>{page.icon}</ListItemIcon>
                                        <ListItemText  ><span className={classes.listItemText}>{page.page}</span></ListItemText>
                                    </ListItemButton>
                                        {this.state.open && page.innerPages.map((xy: any) => {
                                            return (
                                                (page.isAdmin ? true : (xy.category !== undefined ?
                                                    enabledCategories.find((a: any) => xy.category.find((ab: any) => ab === a.type) !== undefined) !== undefined : true)) &&
                                                <ListItem disablePadding className={this.state.pagename === xy.page ?
                                                    classNames(classes.menuItem, classes.listItemText, classes.subMenuItem, classes.selectedMenu) :
                                                    classNames(classes.menuItem, classes.listItemText, classes.subMenuItem)
                                                } key={xy.page} value={xy.page} onClick={this.handleMenuClick(xy.name, xy.page, page)} >

                                                    <ListItemIcon className={classes.listItemIcon}><div /></ListItemIcon>
                                                    <ListItemText><span className={classes.listItemText}>{xy.page}</span></ListItemText>

                                                </ListItem>);
                                        })
                                        }                   </div>
                                )
                            )

                        ))}
                        <Tooltip title="Open TIS Link" placement="right" disableFocusListener disableTouchListener enterDelay={200}>
                            <ListItemButton className={classes.listItem} onClick={this.handleTisLinkRedirect}>
                                <ListItemIcon className={classes.listItemIcon}>
                                    <img src={tisLinkIcon} className={classes.tisLinkIcon} alt="TIS" />
                                </ListItemIcon>
                                <ListItemText><span className={classes.listItemText}>TIS</span></ListItemText>
                            </ListItemButton>
                        </Tooltip>
                    </List>

                    <div className={classes.bottom}>
                        <Tooltip
                            title={this.props.username === '' ? loggedInUser : this.props.username}
                            placement="right"
                        >
                            <ListItemButton className={classNames(classes.listItem, classes.profileItem)} onClick={this.handleListItemClick}>
                                <ListItemIcon className={classes.listItemIcon}>
                                    {hasAvatarImage ? (
                                        <img
                                            src={this.props.userimage === '' ? loggedInUserImage : this.props.userimage}
                                            width="33px"
                                            height="33px"
                                            className={classes.avatorImage}
                                        />
                                    ) : (
                                        <AccountCircle className={classes.iconStyle} />
                                    )}
                                </ListItemIcon>
                                {this.state.open && (
                                    <ListItemText>
                                        <span className={classes.listItemText}>
                                            {this.props.username === '' ? loggedInUser : this.props.username}
                                        </span>
                                    </ListItemText>
                                )}
                            </ListItemButton>
                        </Tooltip>
                        <Dialog open={this.props.dialogOpen} onClose={() => this.props.setDialogOpen(false)}>
                            <DialogTitle><b>Basic Information</b></DialogTitle>
                            <DialogContent style={{ minHeight: '350px', minWidth: '550px' }}>
                                <div style={{ textAlign: 'center' }}>
                                    <div className={classes.avatorStyleContainer}>
                                        <img
                                            src={this.props.userimage === '' ? loggedInUserImage : this.props.userimage}
                                            className={classes.avatorStyle}
                                            alt="User Avatar"
                                        />
                                    </div>
                                </div>
                                <div className={classes.textFieldContainer}>
                                    <TextField
                                        label="First Name"
                                        variant="outlined"
                                        className={this.props.username === '' ? loggedInUser : this.props.username}
                                        defaultValue={firstName}
                                        InputProps={{
                                            readOnly: true,
                                            style: { color: 'grey' }
                                        }}
                                    />
                                    <TextField
                                        label="Last Name"
                                        variant="outlined"
                                        className={this.props.username === '' ? loggedInUser : this.props.username}
                                        defaultValue={lastName}
                                        InputProps={{
                                            readOnly: true,
                                            style: { color: 'grey' }
                                        }}
                                    />
                                </div>
                                <div className={classes.toggleContainer}>
                                    <Box display="flex" alignItems="center">
                                        {/* Text Label */}
                                        <Typography variant="body1" sx={{ mr: 6, fontWeight: 500, color: "#666", fontSize:15 }}>
                                            Receive Bulletin Email Notifications from Trimble
                                        </Typography>

                                        {/* Custom Toggle Switch */}
                                        <FormControlLabel
                                            style={{
                                                marginRight: '10px', marginTop: '8px'
                                            }}
                                            control={
                                                <Box position="relative" display="inline-flex">
                                                    <CustomSwitch
                                                        checked={this.state.toggleChecked}
                                                        onChange={this.handleToggleChange}
                                                        disabled={this.state.isToggleDisabled}
                                                        disableRipple
                                                    />
                                                    {this.state.isToggleDisabled && (
                                                        <CircularProgress
                                                            size={24}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '50%',
                                                                marginTop: -12,
                                                                marginLeft: -12,
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            }
                                            label=""
                                        />
                                    </Box>
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button style={{
                                    borderRadius: '5px', 
                                    border: '2px solid darkgray',
                                    borderWidth: 'thin',
                                    padding: '1px 15px', 
                                }}  onClick={this.handleCloseDialog} color="primary">
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Tooltip title="Sign Out" placement="right">
                            <ListItemButton
                                className={classNames(classes.listItem, classes.signOutItem)}
                                onClick={this.handleLogout}
                            >
                                <ListItemIcon className={classes.listItemIcon}>
                                    <SvgIcon className={classes.iconStyle}>
                                        <path d="M19,3 C20.11,3 21,3.9 21,5 L21,8 L19,8 L19,5 L5,5 L5,19 L19,19 L19,16 L21,16 L21,19 C21,20.1 20.11,21 19,21 L5,21 C3.9,21 3,20.1 3,19 L3,5 C3,3.9 3.9,3 5,3 L19,3 Z M15.5,17 L20.5,12 L15.5,7 L14.09,8.41 L16.67,11 L7,11 L7,13 L16.67,13 L14.09,15.59 L15.5,17 Z" />
                                    </SvgIcon>
                                </ListItemIcon>
                                <ListItemText><span className={classes.listItemText}>Sign Out</span></ListItemText >
                            </ListItemButton>
                        </Tooltip>
                    </div>
                </Drawer>}
                <main className={classNames(
                    window.location.pathname.includes(notificationRoute) ? classes.notificationContent : classes.content,
                    {
                        [window.location.pathname.includes(notificationRoute) ? classes.notificationContentShift : classes.contentShift]: this.state.open
                    }
                )}>
                    <div className={classes.toolbar} />
                    <Routes>
                        <Route path={dashboardRoute} element={<Dashboard />} />
                        <Route path={`${useradminRoute}/*`} element={<UserAdmin />} />
                        <Route path={notificationRoute} element={<Notification />} />
                        {/* Authorization and its nested sub-routes so tabs persist */}
                        <Route path={`${authorizationRoute}/*`} element={<Authorization />}>
                            <Route index element={<MyTrainingAuthorizations />} />
                            <Route path="teamtraining" element={<TeamTrainingAuthorizations />} />
                            <Route path="teamproduct" element={<TeamProductAuthorizations />} />
                            <Route path="alltraining" element={<AllTrainingAuthorizations />} />
                            <Route path="allproduct" element={<AllProductAuthorizations />} />
                        </Route>
                        <Route path={licenseRoute} element={<License />} />
                        <Route path={manualRoute} element={<ServiceManual />} />
                        <Route path={bulletinRoute} element={<ServiceBulletin />} />
                        <Route path={GSInfoRoute} element={<GeneralServiceInformation />} />
                        <Route path={signincallbackRoute} element={<SigninCallBack />} />
                        <Route path={laborTimeGuideRoute} element={<LaborTimeGuide />} />
                        <Route path={downloadsRoute} element={<Downloads />} />
                        <Route path={instrumentConstantsRoute} element={<InstrumentConstants />} />
                    </Routes>
                </main>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => ({
    dialogOpen: state.dashboard.dialogOpen,
    notificationCount: state.notification.totalCount,
    username: state.authService.username,
    userimage: state.authService.userimage
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators({ ...notificationActionCreator, ...navMenuActionCreators, ...viewManualActionCreators, ...dashboardActionCreators }, dispatch);

export default connect(
    mapStateToProps, mapDispatchtoProps
)(withRouterCompat(withStyles(styles as any, { withTheme: true })(NavMenu)));